import React, { useState, useRef, useEffect } from "react";
import TwoPanelSelection from "./TwoPanelSelection";
import { Button, Box, CircularProgress } from "@mui/material";
import { getProjectColumnFields } from "../userProjects/projectColumnDefs";
import { getPackageColumnFields } from "../pkgs/packageColumnDefs";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  fetchUserPreferenceAct,
  saveUserPreferenceAct,
} from "../redux/profile/profileActions";
import { useSelector } from "react-redux";
/**
 * Project selection component using TwoPanelSelection for managing project fields
 */

const ProjectSelection = ({ type, cols = [], selectedSubMenu = "", loopupData }) => {
  console.log("selectedSubMenu", selectedSubMenu);
  console.log("cols in ProjectSelection", cols);
  console.log("loopupData", loopupData)
  // Sample project fields
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const profile = useSelector((state) => state.profile);
  const userPreference = useSelector((state) => state.profile.userPreference);
  const isSaving = useSelector((state) => state.profile.preferenceSaving);

  const [selectedFields, setSelectedFields] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const savedState = useRef([]);
  // const isNestedRef = useRef(false);

  useEffect(() => {
    dispatch(fetchUserPreferenceAct({ email: profile.email, type }));
  }, [type, dispatch, profile.email]);

  // get getColumnFields based on type memoized
  const getColumnFields = React.useMemo(() => {
    if (type === "project") {
      return getProjectColumnFields(t);
    } else if (type === "package") {
      return getPackageColumnFields(t);
    } else if (type === "tagworkspace") {
      return cols;
    }
    return [];
  }, [type, t, cols]);

  // Sync selectedFields with userPreference from Redux store
  useEffect(() => {
    const mapColumnsWithHeaders = (columns) => {
      return columns.map((col) => {
        const matchingField = getColumnFields.find(
          (field) => field.column_name === col.column_name,
        );
        return matchingField
          ? { ...col, headerName: matchingField.headerName }
          : col;
      });
    };

    let columnsToSet = null;
    if (type === "tagworkspace" && selectedSubMenu) {
      if (userPreference?.columns) {
        const subMenuValue = userPreference.columns[selectedSubMenu];
        let cols = [];

        if (Array.isArray(subMenuValue)) {
          cols = subMenuValue;
          // isNestedRef.current = false;
        } else if (
          Array.isArray(
            userPreference.columns.Instrumentation?.[selectedSubMenu],
          )
        ) {
          cols = userPreference.columns.Instrumentation[selectedSubMenu];
          // isNestedRef.current = true;
        } 
        // else {
        //   isNestedRef.current = false;
        // }

        // if (cols.length > 0) {
          columnsToSet = mapColumnsWithHeaders(cols);
        // }
      } else {
        setSelectedFields([]);
        savedState.current = [];
      }
    } else if (
      Array.isArray(userPreference?.columns) &&
      userPreference.preference_key === type &&
      type !== "tagworkspace"
    ) {
      columnsToSet = mapColumnsWithHeaders(userPreference.columns);
    }

    if (columnsToSet) {
      setSelectedFields(columnsToSet);
      savedState.current = [...columnsToSet];
    } else {
      // Clear fields if no valid preference data matches the current type
      setSelectedFields([]);
      savedState.current = [];
    }
  }, [userPreference, selectedSubMenu, type, getColumnFields]);

  // Track save operation status
  // useEffect(() => {
  //   if (isSaving) {
  //     setIsSaveLoading(true);
  //   } else {
  //     setIsSaveLoading(false);
  //   }
  // }, [isSaving]);

  // Track changes between selectedFields and savedState
  useEffect(() => {
    const areFieldsEqual = (fields1, fields2) => {
      if (fields1.length !== fields2.length) return false;
      
      return fields1.every((field, index) => {
        const savedField = fields2[index];
        return (
          field.column_name === savedField.column_name &&
          field.is_visible === savedField.is_visible &&
          field.column_order === savedField.column_order
        );
      });
    };

    const changed = !areFieldsEqual(selectedFields, savedState.current);
    setHasChanges(changed);
  }, [selectedFields]);

  const handleSelectionChange = (newSelection) => {
    setSelectedFields(newSelection);
  };

  const handleSave = () => {
    let payload = selectedFields.map(({ headerName, ...rest }) => rest);

    if (type === "tagworkspace" && selectedSubMenu) {
      const updatedColumns = userPreference?.columns ? { ...userPreference.columns } : { ...loopupData };

      // Check if selectedSubMenu exists directly in updatedColumns
      if (updatedColumns.hasOwnProperty(selectedSubMenu)) {
        // Update directly under selectedSubMenu
        updatedColumns[selectedSubMenu] = payload;
      } else {
        // Update under Instrumentation[selectedSubMenu]
        updatedColumns.Instrumentation = {
          ...updatedColumns.Instrumentation,
          [selectedSubMenu]: payload,
        };
      }

      payload = updatedColumns;
    }

    dispatch(
      saveUserPreferenceAct({
        selectedFields: payload,
        email: profile.email,
        type,
      }),
    );
    savedState.current = [...selectedFields];
    setHasChanges(false);
  };

  const handleReset = () => {
    setSelectedFields([...savedState.current]);
  };

  const handleDefault = () => {
    setSelectedFields([]);
  };

  console.log("selectedFields", selectedFields);
  return (
    <div className="project-selection-container">
      <div className="content-wrapper">
        <TwoPanelSelection
          availableItems={getColumnFields}
          initialSelectedItems={selectedFields}
          idField="column_name"
          displayField="headerName"
          onSelectionChange={handleSelectionChange}
        />

        {/* Action Buttons */}
        <Box className="action-buttons">
          <Button
            variant="contained"
            className="sbtn btn btn-secondary"
            onClick={handleSave}
            disabled={isSaving || !hasChanges }
          
          >
            {isSaving ? "Saving" : "Save"}
          </Button>
          <Button
            className="cnbtn btn cancel-btn"
            variant="outlined"
            onClick={handleReset}
            disabled={isSaving || !hasChanges }
          >
            Reset
          </Button>
          <Button
            className="sbtn btn cancel-btn"
            variant="contained"
            onClick={handleDefault}
            disabled={isSaving}
          >
            Default
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default ProjectSelection;
